import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserSessionService } from './usersession.service';
import { DataService } from './data.service';
import { UserSession } from '../models/usersession';
import * as momenttz from 'moment-timezone';
import 'rxjs/add/operator/map';
import * as jwtDecode from 'jwt-decode';
import { NavigationService } from './navigation.service';
import { AlertService } from './alert.service';
import { RegionService } from './region.service';
declare var require: any;
const timezone = require('src/assets/timezones.json');

@Injectable()
export class AuthenticationService {

  private baseUrl = environment.apiBaseUrl;
  timeZones: any[];
  pageAccess = true;
  sessionData = new UserSession();
  private logoutChannel = new BroadcastChannel('logout_channel');
  private loginChannel = new BroadcastChannel('login_channel');

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private alertService: AlertService,
    private navigationService : NavigationService,
    private regionService: RegionService,
    private sessionService: UserSessionService) {
    this.getTimeZones();
  }

  // testing(){
  //   return this.http.get<any>('https://nrt.xenovex.com/en/menu-view/1/').map(response => {
  //     return response;
  //   });
  // }
  
  login(username: string, password: string) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
      });

    const data = { username: username, password: password };
    return this.http.post<any>(this.baseUrl + '/api/login', data, { headers: headers })
      .map(user => {
         if (user && user.value?.jwt) {
         // if (user) {
          this.clearCachedMenu();
           const decodedToken = jwtDecode(user.value.jwt);
           this.sessionData.authToken = user.value.jwt;
           this.sessionData.email = decodedToken['email'];
           this.sessionData.districtId = decodedToken['district_id'];
          this.sessionData.userId = decodedToken['user_id'];
          this.sessionData.isFirstLogin = user.value.ispasschecked;
          this.sessionData.isagenable = decodedToken['isagenable'];
          this.sessionData.roleId = decodedToken['role'];
          this.sessionData.userEmail =decodedToken['email'];
          this.sessionData.usermobile =decodedToken['mobile'];
          this.sessionData.statusId = user.value.status_id;
          this.sessionData.subUserApplicant = decodedToken['subuser_applicant'];
          this.sessionData.userFullName = decodedToken['displayname'];
          this.sessionData.subuser_type = decodedToken['subuser_type'];
          this.sessionData.is192aexist = decodedToken['is192aexist'];
          this.sessionData.isTANMANG = user.value?.is_applicant || user.value?.is_district;
          this.sessionData.isWbApplicant = user.value?.is_wb_applicant;
          this.sessionData.isWbSubUser = user.value?.is_wb_subuser;
          this.sessionService.create(this.sessionData);
          this.loginChannel.postMessage("login");
          
        }
        return user;
      });
  }

  isAuthenticated() {
    return !!this.sessionService.userId() && !!this.sessionService.authToken();
  }
  
  forgotpasswordUser(username: any) {
    let data = {
      username: username
    }
    return this.dataService.post('/api/user/password/forgot', data).map(response => {
      return response;
    });
    
  }

  forgetPasswordChange(data: any){
    return this.dataService.post('/api/forgot/password/reset', data).map(response => {
      return response;
    })
  }
  
  getVersion() {
    return this.dataService.getData('/getVersion', null).map(response => {
      return response;
    });
    
  }

  getNewVersion(){
    return this.dataService.getData('/getNewVersion', null).map(response => {
      return response;
    })
  }

  versionDets(data: any){
    return this.dataService.post('/versionDets', data).map(response => {
      return response;
    })
  }

  getIPLocation(){
    return this.dataService.getData('/api/getipLocation', null).map(response => {
      return response;
    })
  }  

  changepasswordUser(oldpass: any, newpass: any) {
    let data = {
      current_password : oldpass,
      new_password :  newpass
    }
    return this.dataService.post('/api/user/password/change', data).map(response => {
      return response;
    });
    
  }
  
  isPageAccessAvailable(pageUrl, pageTitle) {
    const rolePages = this.sessionService.getLocalStorageWithKey('role') ? this.sessionService.getLocalStorageWithKey('role') : '[]';
    const pages = JSON.parse(rolePages);
    const paths = ['/unauthorized', '/dashboard'];
    if (pages && pages.length > 0) {
      pages.forEach(field => {
        if (field.path) {
          paths.push(field.path);
          paths.push(field.title);
        }
        if (field.submenu && field.submenu.length > 0) {
          field.submenu.forEach(field1 => {
            if (field1.path) {
              paths.push(field1.path);
              paths.push(field1.title);
              if (field1.path === '/servicehosts/1' || field1.path === '/servicehosts/2') {
                paths.push('Test');
              }
              if (field1.path === '/hosters/1' || field1.path === '/hosters/2') {
                paths.push('Hosters');
              }
            }
          });
        }
      });
      this.pageAccess = (paths.indexOf(pageUrl) >= 0) || (paths.indexOf(pageTitle) >= 0) ? true : false;
    }
    return this.pageAccess;
  }

  hasRequiredPermission(permission) {
    for (let i = 0; i < permission.length; i++) {
      if (permission[i] === this.sessionService.roleId()) {
        return true;
      }
    }
    return false;
  }

  getTimeZones() {
    this.timeZones = timezone.timeZone;
  }

  getBrowserTimeZone(): string {
    const zoneName = momenttz.tz.guess();
    const temptimezone = momenttz.tz(zoneName).zoneAbbr();
    const filterZone = this.timeZones.find(i => i.abbr === temptimezone);
    if (filterZone) {
      return filterZone.value;
    }
    return '';
  }

  clearCachedMenu() {
    this.dataService.clearCache();
    this.regionService.clearCache();
  }

  clearSession() {
    this.sessionService.destroy();
    this.clearCachedMenu();
  }

  broadcastMessage(){
    this.logoutBroadcast();
    this.loginBroadcast();
  }

  logoutBroadcast(){
    this.logoutChannel.onmessage = (message) => {
      if (message.data === 'logout' && document.hidden) {
        if(localStorage.getItem('isLoggedin')){
          this.clearCachedMenu();
          this.sessionService.destroy();
        }
        location.reload();
      }
    };
  }

  loginBroadcast(){
    this.loginChannel.onmessage = (message) => {
      if (message.data === 'login' && document.hidden) {
        location.reload();
      }
    };
  }

  logOut() {
   
    if(this.sessionService.getMobile() === '' || this.sessionService.getMobile() === undefined)
    {
      this.logoutChannel.postMessage('logout');
      this.clearCachedMenu();
      this.sessionService.destroy();
      this.navigationService.goToLogin();
    } else {
      // let data = {};
      // if(this.sessionService.roleId() == 7){
      //   data={
      //     username:  this.sessionService.getUserName()
      //   };
      // }else{
      //   data={
      //     username:  this.sessionService.getMobile()
      //   };
      // }
      const data={
        username:  this.sessionService.getMobile()
      };
      
      this.dataService.post('/api/logout', data).subscribe((res) => {
        if(res && res.isSuccess)
        {
        this.clearCachedMenu();
        this.sessionService.destroy();
        this.navigationService.goToLogin();
        this.logoutChannel.postMessage('logout');
        } else {
          this.alertService.error(res.value);
          
        }
  
      });
    }
    
    
  }
}
